import { HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ApiService } from "src/app/services/api.service";
import { ErrorType } from "src/app/enums/error-type.enum";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";

@Component({
  selector: "fury-loader-content",
  templateUrl: "./loader-content.component.html",
  styleUrls: ["./loader-content.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
  encapsulation: ViewEncapsulation.None,
})
export class LoaderContentComponent implements OnInit, OnDestroy {
  ngUnSubscribe = new Subject<void>();
  loaderContentForm = new FormGroup({
    loaderTitleContent: new FormControl("", [Validators.required]),
    loaderInitialContent: new FormControl("", [Validators.required]),
    loaderProgressContent: new FormControl("", [Validators.required]),
    loaderWarningContent: new FormControl("", [Validators.required]),
  });

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.getLoaderContent();
  }
  getLoaderContent() {
    this.apiService
      .get(endpoints.settings.loaderContent.getLoaderContent)
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.loaderContentForm.setValue(res.body?.loaderContentSettings);
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        }
      });
  }

  updateLoaderContent() {
    if (this.loaderContentForm.invalid) {
      this.loaderContentForm.markAllAsTouched();
      return;
    }
    this.apiService
      .post(endpoints.settings.loaderContent.saveLoaderContent, this.loaderContentForm.value)
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          this.apiService.alert(res.body?.message, ErrorType.Success);
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err?.message, ErrorType.Error);
        },
      });
  }
  ngOnDestroy() {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
